"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _component = _interopRequireDefault(require("@loadable/component"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _useTheme = _interopRequireDefault(require("@material-ui/core/styles/useTheme"));

var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));

var _Container = _interopRequireDefault(require("@material-ui/core/Container"));

var _PageContext = _interopRequireDefault(require("@micado-digital/react-ui/context/PageContext"));

var _Filter = _interopRequireDefault(require("@micado-digital/react-filter/Filter"));

var _ConditionalWrapper = _interopRequireDefault(require("@micado-digital/react-ui/components/ConditionalWrapper"));

var _useFetch = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useFetch"));

var _useFilter = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useFilter"));

var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));

var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));

var _parseStringToArray2 = _interopRequireDefault(require("../../utils/parseStringToArray"));

var _de = _interopRequireDefault(require("../../locals/de.json"));

var _en = _interopRequireDefault(require("../../locals/en.json"));

var _it = _interopRequireDefault(require("../../locals/it.json"));

var _ProductOverview = _interopRequireDefault(require("./ProductOverview01.styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Buttons = (0, _component.default)(function () {
  return import("./Buttons");
});
var Counter = (0, _component.default)(function () {
  return import("./Counter");
});
var Drawer = (0, _component.default)(function () {
  return import("@material-ui/core/Drawer");
});
var DrawerToolbar = (0, _component.default)(function () {
  return import("../../components/DrawerToolbar");
});
var FilterButton = (0, _component.default)(function () {
  return import("./Filter/FilterButton");
});
var FilterConnector = (0, _component.default)(function () {
  return import("./Filter/FilterConnector");
});
var Groups = (0, _component.default)(function () {
  return import("./Groups");
});
var List = (0, _component.default)(function () {
  return import("./List");
});
var Preloader = (0, _component.default)(function () {
  return import("../../components/Preloader");
});
var SelectedFilter = (0, _component.default)(function () {
  return import("./SelectedFilter");
});
var Sort = (0, _component.default)(function () {
  return import("./Sort");
});

var ProductOverview01 = function ProductOverview01(_ref) {
  var _ref$defaultLang = _ref.defaultLang,
      defaultLang = _ref$defaultLang === void 0 ? "de" : _ref$defaultLang,
      _ref$displayedFeature = _ref.displayedFeatures,
      displayedFeatures = _ref$displayedFeature === void 0 ? [] : _ref$displayedFeature,
      _ref$excludedFilter = _ref.excludedFilter,
      excludedFilter = _ref$excludedFilter === void 0 ? ["groups"] : _ref$excludedFilter,
      _ref$filterListURL = _ref.filterListURL,
      filterListURL = _ref$filterListURL === void 0 ? "" : _ref$filterListURL,
      _ref$listURL = _ref.listURL,
      listURL = _ref$listURL === void 0 ? "" : _ref$listURL,
      _ref$page = _ref.page,
      page = _ref$page === void 0 ? 1 : _ref$page,
      _ref$pageSize = _ref.pageSize,
      pageSize = _ref$pageSize === void 0 ? 12 : _ref$pageSize,
      productTeaserComponent = _ref.productTeaserComponent,
      _ref$selectedFilter = _ref.selectedFilter,
      selectedFilter = _ref$selectedFilter === void 0 ? [] : _ref$selectedFilter,
      _ref$selectedGroup = _ref.selectedGroup,
      selectedGroup = _ref$selectedGroup === void 0 ? "" : _ref$selectedGroup,
      _ref$showCategories = _ref.showCategories,
      showCategories = _ref$showCategories === void 0 ? true : _ref$showCategories,
      _ref$sort = _ref.sort,
      sort = _ref$sort === void 0 ? 7 : _ref$sort;
  var REACT_APP_PATH = process.env.REACT_APP_PATH;

  var _useContext = (0, _react.useContext)(_PageContext.default),
      _useContext2 = _slicedToArray(_useContext, 1),
      pageData = _useContext2[0];

  var _ref2 = pageData || {},
      pageDataLang = _ref2.lang;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      categoriesOpen = _useState2[0],
      setCategoriesOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      filterOpen = _useState4[0],
      setFilterOpen = _useState4[1];

  var _useState5 = (0, _react.useState)({}),
      _useState6 = _slicedToArray(_useState5, 2),
      localValues = _useState6[0],
      setLocalValues = _useState6[1];

  var _useState7 = (0, _react.useState)(defaultLang),
      _useState8 = _slicedToArray(_useState7, 2),
      lang = _useState8[0],
      setLang = _useState8[1];

  var refForm = (0, _react.useRef)(null);
  var refList = (0, _react.useRef)(null);
  var filter = (0, _useFilter.default)(refForm, {
    groups: selectedGroup !== null && selectedGroup !== void 0 ? selectedGroup : "",
    lang: lang,
    page: page,
    pageSize: pageSize,
    sort: sort
  }, [{
    page: 1
  }]);

  var _filterListURL = filterListURL ? filterListURL : "".concat(REACT_APP_PATH, "/Micado.Shop.Web/Micado.Shop.Web.IO.Api.ProductApi/FilterList.api");

  var _listURL = listURL ? listURL : "".concat(REACT_APP_PATH, "/Micado.Shop.Web/Micado.Shop.Web.IO.Api.ProductApi/List.api");

  var products = (0, _useFetch.default)({
    data: _objectSpread(_objectSpread({}, filter), {}, {
      action: "filter"
    }),
    url: _listURL,
    method: "GET"
  }, [filter], !(0, _isEmpty.default)(filter));

  var _ref3 = products || {},
      _ref3$entries = _ref3.entries,
      entries = _ref3$entries === void 0 ? 0 : _ref3$entries,
      _ref3$items = _ref3.items,
      items = _ref3$items === void 0 ? [] : _ref3$items,
      _loading = _ref3._loading;

  var theme = (0, _useTheme.default)();
  var isMobile = (0, _useMediaQuery.default)(theme.breakpoints.down("sm"));
  var css = (0, _ProductOverview.default)();
  var l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  (0, _react.useEffect)(function () {
    if (!pageDataLang) return;
    setLang(pageDataLang);
  }, [pageDataLang]);
  (0, _react.useEffect)(function () {
    var _filter$groups, _filter$lang, _filter$price;

    setFilterOpen(false);
    var _localValues = {};

    for (var key in filter) {
      var _parseStringToArray;

      _localValues[key] = (_parseStringToArray = (0, _parseStringToArray2.default)(filter[key])) !== null && _parseStringToArray !== void 0 ? _parseStringToArray : [];
    }

    _localValues.groups = (_filter$groups = filter.groups) !== null && _filter$groups !== void 0 ? _filter$groups : selectedGroup;
    _localValues.lang = (_filter$lang = filter.lang) !== null && _filter$lang !== void 0 ? _filter$lang : lang;
    _localValues.page = filter.page ? parseInt(filter.page) : page;
    _localValues.pageSize = filter.pageSize ? parseInt(filter.pageSize) : pageSize;
    _localValues.price = (_filter$price = filter === null || filter === void 0 ? void 0 : filter.price) !== null && _filter$price !== void 0 ? _filter$price : "";
    _localValues.sort = filter.sort ? parseInt(filter.sort) : sort;
    setLocalValues(_localValues); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  var handleClearFilter = function handleClearFilter() {
    setLocalValues({
      groups: selectedGroup !== null && selectedGroup !== void 0 ? selectedGroup : "",
      lang: lang,
      page: page,
      pageSize: pageSize,
      price: "",
      sort: sort
    });
    handleSubmit(100);
  };

  var handleGroupClick = function handleGroupClick() {
    var groups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    setLocalValues({
      groups: groups,
      lang: lang,
      page: page,
      pageSize: pageSize,
      price: "",
      sort: sort
    });
    handleSubmit(100);
  };

  var handlePaginate = function handlePaginate(e, page) {
    setLocalValues(_objectSpread(_objectSpread({}, localValues), {}, {
      page: page
    }));
    handleSubmit(100);
  };

  var handleSubmit = function handleSubmit() {
    var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
    setTimeout(function () {
      submitForm();
    }, delay);
  };

  var submitForm = function submitForm() {
    var evt = new CustomEvent("submit", {
      bubbles: true,
      cancelable: true
    });
    refForm.current.dispatchEvent(evt);
  };

  return /*#__PURE__*/_react.default.createElement(_Container.default, {
    className: (0, _clsx2.default)(css.productOverview, "mco-shop-product-overview"),
    maxWidth: "lg"
  }, showCategories && /*#__PURE__*/_react.default.createElement(_ConditionalWrapper.default, {
    condition: isMobile,
    wrapper: function wrapper(children) {
      return /*#__PURE__*/_react.default.createElement(Drawer, {
        anchor: "left",
        classes: {
          paper: (0, _clsx2.default)(css.paper, "mco-shop-paper")
        },
        open: categoriesOpen,
        variant: "persistent",
        onClose: setCategoriesOpen
      }, children);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)(css.groups, "mco-shop-product-overview__groups")
  }, isMobile && /*#__PURE__*/_react.default.createElement(DrawerToolbar, {
    setOpen: setCategoriesOpen,
    title: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.productOverview.titles.categories",
      l: l
    })
  }), /*#__PURE__*/_react.default.createElement(Groups, {
    lang: lang,
    localValues: localValues,
    setLocalValues: setLocalValues,
    setOpen: setCategoriesOpen,
    onSubmit: handleGroupClick
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)(css.contentColumn, "mco-shop-product-overview__content", _defineProperty({}, css.hasLeftColumn, showCategories))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)(css.wrapper, "mco-shop-product-overview__wrapper")
  }, /*#__PURE__*/_react.default.createElement(Counter, {
    itemsCounter: entries,
    lang: lang,
    loading: _loading
  }), isMobile && /*#__PURE__*/_react.default.createElement(Buttons, {
    lang: lang,
    setCategoriesOpen: setCategoriesOpen,
    setFilterOpen: setFilterOpen,
    showCategories: showCategories
  })), /*#__PURE__*/_react.default.createElement(_Filter.default, {
    api: _filterListURL,
    excludedFilter: excludedFilter,
    lang: lang,
    localValues: localValues,
    preSelectedValues: {},
    refForm: refForm,
    selectedFilter: selectedFilter,
    setLocalValues: setLocalValues
  }, /*#__PURE__*/_react.default.createElement(_ConditionalWrapper.default, {
    condition: isMobile,
    wrapper: function wrapper(children) {
      return /*#__PURE__*/_react.default.createElement(Drawer, {
        anchor: "left",
        classes: {
          paper: (0, _clsx2.default)(css.paper, "mco-shop-paper")
        },
        open: filterOpen,
        variant: "persistent",
        onClose: setFilterOpen
      }, children);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)(css.filter, "mco-shop-product-overview__filter")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)(css.filterWrapper, "mco-shop-product-overview__filter-wrapper")
  }, /*#__PURE__*/_react.default.createElement(FilterConnector, {
    lang: lang,
    maxVisibleOptions: 6,
    setFilterOpen: setFilterOpen,
    onSubmit: handleSubmit
  }), !isMobile && /*#__PURE__*/_react.default.createElement(Sort, {
    lang: lang,
    onSubmit: handleSubmit
  })), isMobile && /*#__PURE__*/_react.default.createElement(FilterButton, {
    lang: lang
  }))), /*#__PURE__*/_react.default.createElement(SelectedFilter, {
    lang: lang,
    onClearFilter: handleClearFilter,
    onSubmit: handleSubmit
  })), _loading ? /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)(css.preloader, "mco-shop-product-overview__preloader")
  }, /*#__PURE__*/_react.default.createElement(Preloader, null)) : /*#__PURE__*/_react.default.createElement(List, {
    currentPage: localValues.page,
    displayedFeatures: displayedFeatures,
    items: items,
    itemsCounter: entries,
    itemsPerPage: pageSize,
    lang: lang,
    loading: _loading,
    productTeaserComponent: productTeaserComponent,
    ref: refList,
    showCategories: showCategories,
    onPaginate: handlePaginate
  })));
};

ProductOverview01.propTypes = {
  defaultLang: _propTypes.default.string,
  displayedFeatures: _propTypes.default.array,
  filterListURL: _propTypes.default.string,
  listURL: _propTypes.default.string,
  page: _propTypes.default.number,
  pageSize: _propTypes.default.number,
  productTeaserComponent: _propTypes.default.object,
  selectedFilter: _propTypes.default.array,
  selectedGroup: _propTypes.default.string,
  showCategories: _propTypes.default.bool,
  sort: _propTypes.default.number
};
var _default = ProductOverview01;
exports.default = _default;